import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {
  StepOneLeftPanelComponent
} from "./pages/register/step-one/step-one-left-panel/step-one-left-panel.component";
import {
  StepOneRightPanelComponent
} from "./pages/register/step-one/step-one-right-panel/step-one-right-panel.component";
import {
  StepTwoLeftPanelComponent
} from "./pages/register/step-two/step-two-left-panel/step-two-left-panel.component";
import {
  StepTwoRightPanelComponent
} from "./pages/register/step-two/step-two-right-panel/step-two-right-panel.component";
import {
  ForgotPasswordLeftPanelComponent
} from "./pages/forgot-password/forgot-password-left-panel/forgot-password-left-panel.component";
import {
  ForgotPasswordRightPanelComponent
} from "./pages/forgot-password/forgot-password-right-panel/forgot-password-right-panel.component";
import {
  SetPasswordLeftPanelComponent
} from "./pages/set-password/set-password-left-panel/set-password-left-panel.component";
import {
  SetPasswordRightPanelComponent
} from "./pages/set-password/set-password-right-panel/set-password-right-panel.component";
import {ResetPasswordGuard} from "../shared/guards/reset-password.guard";
import {
  StepFourLeftPanelComponent
} from "./pages/register/step-four/step-four-left-panel/step-four-left-panel.component";
import {
  StepFourRightPanelComponent
} from "./pages/register/step-four/step-four-right-panel/step-four-right-panel.component";
import {
  StepFiveLeftPanelComponent
} from "./pages/register/step-five/step-five-left-panel/step-five-left-panel.component";
import {
  StepFiveRightPanelComponent
} from "./pages/register/step-five/step-five-right-panel/step-five-right-panel.component";
import {
  StepThreeLeftPanelComponent
} from "./pages/register/step-three/step-three-left-panel/step-three-left-panel.component";
import {
  StepThreeRightPanelComponent
} from "./pages/register/step-three/step-three-right-panel/step-three-right-panel.component";
import {RegisterStepOneGuard} from "../shared/guards/register-step-one.guard";
import {RegisterStepTwoGuard} from "../shared/guards/register-step-two.guard";
import {
  RegisterStepThreeGuard
} from "../shared/guards/register-step-three.guard";
import {RegisterStepFourGuard} from "../shared/guards/register-step-four.guard";
import {RegisterStepFiveGuard} from "../shared/guards/register-step-five.guard";
import {
  PageNotFoundLeftPanelComponent
} from "../shared/components/external-page-not-found/page-not-found-image/page-not-found-left-panel.component";
import {
  PageNotFoundRightPanelComponent
} from "../shared/components/external-page-not-found/page-not-found-text/page-not-found-right-panel.component";
import {
  LoginLeftPanelComponent
} from "./pages/login/login-left-panel/login-left-panel.component";
import {
  LoginRightPanelComponent
} from "./pages/login/login-right-panel/login-right-panel.component";
import {
  WarningLeftPanelComponent
} from "./pages/warning/warning-left-panel/warning-left-panel.component";
import {
  WarningRightPanelComponent
} from "./pages/warning/warning-right-panel/warning-right-panel.component";
import {
  MessageLeftPanelComponent
} from "./pages/message/message-left-panel/message-left-panel.component";
import {
  MessageRightPanelComponent
} from "./pages/message/message-right-panel/message-right-panel.component";

const authenticationRoutes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    children: [
      {
        path: '',
        component: LoginLeftPanelComponent,
        outlet: 'left-panel'
      },
      {
        path: '',
        component: LoginRightPanelComponent,
        outlet: 'right-panel',
      },
    ]
  },
  {
    path: 'step-warning',
    children: [
      {
        path: '',
        children: [
          {
            path: '',
            component: WarningLeftPanelComponent,
            outlet: 'left-panel'
          },
          {
            path: '',
            component: WarningRightPanelComponent,
            outlet: 'right-panel',
          }
        ]
      }
    ]
  },
  {
    path: 'message',
    children: [
      {
        path: '',
        children: [
          {
            path: '',
            component: MessageLeftPanelComponent,
            outlet: 'left-panel'
          },
          {
            path: '',
            component: MessageRightPanelComponent,
            outlet: 'right-panel',
          }
        ]
      }
    ]
  },
  {
    path: 'two-factor-authentication',
    children: [
      {
        path: '',
        children: [
          {
            path: '',
            component: StepThreeLeftPanelComponent,
            outlet: 'left-panel'
          },
          {
            path: '',
            component: StepThreeRightPanelComponent,
            outlet: 'right-panel',
          }
        ]
      },
    ]
  },
  {
    path: 'register',
    children: [
      {
        path: '',
        redirectTo: 'step-1',
        pathMatch: 'full'
      },
      {
        path: 'step-1',
        canActivate: [RegisterStepOneGuard],
        children: [
          {
            path: '',
            component: StepOneLeftPanelComponent,
            outlet: 'left-panel'
          },
          {
            path: '',
            component: StepOneRightPanelComponent,
            outlet: 'right-panel',
          }
        ]
      },
      {
        path: 'step-2',
        canActivate: [RegisterStepTwoGuard],
        children: [
          {
            path: '',
            component: StepTwoLeftPanelComponent,
            outlet: 'left-panel'
          },
          {
            path: '',
            component: StepTwoRightPanelComponent,
            outlet: 'right-panel'
          },
        ]
      },
      {
        path: 'step-3',
        canActivate: [RegisterStepThreeGuard],
        children: [
          {
            path: '',
            component: StepThreeLeftPanelComponent,
            outlet: 'left-panel'
          },
          {
            path: '',
            component: StepThreeRightPanelComponent,
            outlet: 'right-panel',
          }
        ]
      },
      {
        path: 'step-4',
        canActivate: [RegisterStepFourGuard],
        children: [
          {
            path: '',
            component: StepFourLeftPanelComponent,
            outlet: 'left-panel'
          },
          {
            path: '',
            component: StepFourRightPanelComponent,
            outlet: 'right-panel',
          }
        ]
      },
      {
        path: 'step-5',
        canActivate: [RegisterStepFiveGuard],
        children: [
          {
            path: '',
            component: StepFiveLeftPanelComponent,
            outlet: 'left-panel'
          },
          {
            path: '',
            component: StepFiveRightPanelComponent,
            outlet: 'right-panel',
          }
        ]
      }
    ]
  },
  {
    path: 'password',
    children: [
      {
        path: '',
        redirectTo: 'forgot',
        pathMatch: 'full'
      },
      {
        path: 'forgot',
        children: [
          {
            path: '',
            component: ForgotPasswordLeftPanelComponent,
            outlet: 'left-panel'
          },
          {
            path: '',
            component: ForgotPasswordRightPanelComponent,
            outlet: 'right-panel'
          },
        ]
      },
      {
        path: 'set',
        canActivate: [ResetPasswordGuard],
        children: [
          {
            path: '',
            component: SetPasswordLeftPanelComponent,
            outlet: 'left-panel'
          },
          {
            path: '',
            component: SetPasswordRightPanelComponent,
            outlet: 'right-panel'
          },
        ]
      }
    ]
  },
  {
    path: '**',
    children: [
      {
        path: '',
        component: PageNotFoundLeftPanelComponent,
        outlet: 'left-panel'
      },
      {
        path: '',
        component: PageNotFoundRightPanelComponent,
        outlet: 'right-panel',
      }
    ]
  },
]

@NgModule({
  imports: [RouterModule.forChild(authenticationRoutes)],
  exports: [RouterModule]
})
export class AuthenticationRoutingModule {
}
